export const environment = {
    development: true,
    apiUrl: 'https://gstn.org.in/GSTAT-SUB-STAFF-CONSULTANTS-BO',//http://localhost:80/GSTAT-SUB-STAFF-CONSULTANTS-BO  // https://gstn.org.in/GSTAT-SUB-STAFF-CONSULTANTS-BO
    recaptcha: {
         siteKey: '6Lcjcr0ZAAAAAKgmOglmpc3ZZmbHNbQe8ah3cRDY', //production
        //siteKey:'6LfQ8UspAAAAACHV-_AWjYdjpOi2zckEHaWm50u7'  // localhost
      },
};
